/**
 * Shared layout for /terms, /privacy, /refund. Keeps typography and
 * navigation consistent across legal pages.
 */
import { Link } from "react-router-dom";

interface LegalShellProps {
  title: string;
  /** Format: "May 8, 2026" — kept human-readable for legal-page convention. */
  effectiveDate: string;
  children: React.ReactNode;
}

export function LegalShell({ title, effectiveDate, children }: LegalShellProps) {
  return (
    <main className="mx-auto flex min-h-full max-w-3xl flex-col gap-6 p-6 pb-16 text-white">
      <header>
        <Link
          to="/"
          className="text-sm uppercase tracking-widest opacity-50 hover:opacity-100"
        >
          ← Curvle
        </Link>
        <h1 className="mt-4 text-3xl font-bold tracking-tight">{title}</h1>
        <p className="mt-1 text-xs uppercase tracking-widest opacity-50">
          Effective {effectiveDate}
        </p>
      </header>

      <article className="prose prose-invert max-w-none text-sm leading-relaxed [&_h2]:mt-8 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:uppercase [&_h2]:tracking-widest [&_h2]:opacity-70 [&_h3]:mt-4 [&_h3]:text-sm [&_h3]:font-semibold [&_p]:opacity-85 [&_li]:opacity-85 [&_a]:underline">
        {children}
      </article>

      <footer className="mt-6 border-t border-white/10 pt-6 text-center text-xs opacity-50">
        Curvle is operated by Thoughtplanet Advisory Services LLP, India.{" "}
        <Link to="/pricing" className="underline">Pricing</Link> ·{" "}
        <Link to="/terms" className="underline">Terms</Link> ·{" "}
        <Link to="/privacy" className="underline">Privacy</Link> ·{" "}
        <Link to="/refund" className="underline">Refund</Link>
      </footer>
    </main>
  );
}
